import React from 'react';
import PopUp from '../../HOC/PopUp';

const CardlessEMIDetails = ({ tenure, onCloseClick, isHDFC = true }) => {
  return (
    <PopUp onClose={() => onCloseClick(false)}>
      <>
        <div class='modal-content'>
          <div class='modal-body clearfix'>
            <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12 emi-tenure-header'>
              <h2>EMI Details</h2>
            </div>
            {isHDFC ? (
              tenure?.offer_scheme?.product_details?.map((product, index) => (
                <div
                  key={`cardless-product-${tenure?.tenure_in_month}-${index}`}
                >
                  {product?.product_display_name ===
                  'NO_PRODUCT_DISPLAY_NAME' ? null : (
                    <div class='row emi-product-details'>
                      <div class='col-7 text-left fw-600'>
                        <p>{product?.product_display_name}</p>
                      </div>
                    </div>
                  )}
                  <div class='row emi-product-details'>
                    <div class='col-7 text-left'>
                      <p>Item value</p>
                    </div>
                    <div class='col-5 text-right'>
                      <p class=''>
                        ₹
                        {product?.product_amount
                          ? product?.product_amount / 100
                          : 0}
                      </p>
                    </div>
                  </div>
                  <div class='row emi-product-details'>
                    <div class='col-7 text-left'>
                      <p>Interest(charge by bank)</p>
                    </div>
                    <div class='col-5 text-right'>
                      <p class=''>₹{product?.bank_interest_rate / 100}</p>
                    </div>
                  </div>
                  {product?.product_discount > 0 ? (
                    <div class='row emi-product-details'>
                      <div class='col-7 text-left'>
                        <p class='text-green'>Product Instant Discount</p>
                      </div>
                      <div class='col-5 text-right'>
                        <p class='text-green'>
                          {' '}
                          ₹{product?.product_discount / 100}
                        </p>
                      </div>
                    </div>
                  ) : null}
                  {product?.subvention_cashback_discount > 0 ? (
                    <div class='row emi-product-details'>
                      <div class='col-7 text-left'>
                        <p class='text-green'>EMI Discount/Cashback </p>
                      </div>
                      <div class='col-5 text-right'>
                        <p class='text-green'>
                          ₹{product?.subvention_cashback_discount / 100}
                        </p>
                      </div>
                    </div>
                  ) : null}

                  {product?.additional_cashback ? (
                    <div class='row emi-product-details'>
                      <div class='col-7 text-left'>
                        <p class='text-green'>Add.Cashback</p>
                      </div>
                      <div class='col-5 text-right'>
                        <p class='text-green'>₹{product?.additional_cashback}</p>
                      </div>
                    </div>
                  ) : null}
                  <hr/>
                  <div class='row emi-deferred-total-amount'>
                    <div class='col-7 text-left'>
                      <p>Total EMI for {tenure?.tenure_in_month} months </p>
                    </div>
                    <div class='col-5 text-right'>
                      <p>
                        {' '}
                        ₹
                        {(product?.product_amount +
                          product?.bank_interest_rate -
                          product?.product_discount -
                          product?.subvention_cashback_discount) /
                          100}
                      </p>
                    </div>
                  </div>
                  <hr/>
                </div>
              ))
            ) : (
              <>
                <div class='row emi-product-details'>
                  <div class='col-7 text-left'>
                    <p>EMI</p>
                  </div>
                  <div class='col-5 text-right'>
                    <p>
                      ₹
                      {(tenure?.emi_amount?.amount
                        ? tenure?.emi_amount?.amount / 100
                        : tenure?.monthly_installment / 100
                      )?.toFixed(2)}
                    </p>
                  </div>
                </div>
                <div class='row emi-product-details'>
                  <div class='col-7 text-left'>
                    <p>Interest(charge by bank)</p>
                  </div>
                  <div class='col-5 text-right'>
                    <p class=''>
                      {tenure?.interest_rate
                        ? tenure?.interest_rate
                        : tenure?.bank_interest_rate / 10000}
                      %
                    </p>
                  </div>
                </div>
                <hr/>
                <div class='row emi-deferred-total-amount'>
                  <div class='col-7 text-left'>
                    <p>
                      Total EMI for{' '}
                      {tenure?.tenure ? tenure.tenure : tenure?.tenure_in_month}{' '}
                      months
                    </p>
                  </div>
                  <div class='col-5 text-right'>
                    <p class=''>
                      ₹
                      {(
                        (tenure?.emi_amount?.amount
                          ? tenure?.emi_amount?.amount * tenure?.tenure
                          : tenure?.tenure_in_month *
                            tenure?.monthly_installment) / 100
                      )?.toFixed(2)}
                    </p>
                  </div>
                </div>
                <hr/>
              </>
            )}
          </div>
        </div>
      </>
    </PopUp>
  );
};

export default CardlessEMIDetails;
